import { ReorderDialog, IReorderableItem } from "../../components/ReorderDialog";

interface IReorderDialogsSectionProps {
  // Items reorder dialog
  itemsDialogVisible: boolean;
  itemsForReorder: IReorderableItem[];
  onHideItemsDialog: () => void;
  onSaveItemsReorder: (orderedIds: number[]) => Promise<void>;

  // Categories reorder dialog
  categoriesDialogVisible: boolean;
  categoriesForReorder: IReorderableItem[];
  onHideCategoriesDialog: () => void;
  onSaveCategoriesReorder: (orderedIds: number[]) => Promise<void>;

  loading: boolean;
}

export const ReorderDialogsSection = ({
  itemsDialogVisible,
  itemsForReorder,
  onHideItemsDialog,
  onSaveItemsReorder,
  categoriesDialogVisible,
  categoriesForReorder,
  onHideCategoriesDialog,
  onSaveCategoriesReorder,
  loading,
}: IReorderDialogsSectionProps) => {
  return (
    <>
      <ReorderDialog
        visible={itemsDialogVisible}
        onHide={onHideItemsDialog}
        title="Подреждане на елементи"
        items={itemsForReorder}
        onSave={onSaveItemsReorder}
        loading={loading}
      />

      <ReorderDialog
        visible={categoriesDialogVisible}
        onHide={onHideCategoriesDialog}
        title="Подреждане на категории"
        items={categoriesForReorder}
        onSave={onSaveCategoriesReorder}
        loading={loading}
      />
    </>
  );
};
